

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';

@Component({
  selector: 'app-add-edit-employee-mission',
  templateUrl: './add-edit-employee-mission.component.html',
  styleUrls: ['./add-edit-employee-mission.component.scss']
})
export class AddEditEmployeeMissionComponent implements OnInit {

  isEditMode = false;
  missionId: number | null = null;
  loading = false;
  submitting = false;

  employeesdropdown: any[] = [];

  missionTypes : any[] = [];

  formData: any = {
    name: '',
    descrption: '',
    missionLocation: '',
    missionType: 0,
    isPaid: false,
    employeeId: null,
    visitStartDateTime: null,
    visitEndDateTime: null,
    isClientVisit: false,
    clientName: '',
    clientPhone: '',
    hasUpcomingVisit: false,
    upcomingVisitDate: null,
    isCollectedFromClient: false,
    collectedAmountFromClient: null,
    collectionReason: '',
    collectionDate: null,
    expenses: [],
    transportations: []
  };

  // Transportation row being added
  newTransportation: any = {
    fromDestination: '',
    toDestination: '',
    cost: 0,
    order: 1,
    fromTime: null,
    toTime: null
  };

  // Expense row being added
  newExpense: any = {
    description: '',
    amount: 0
  };

  constructor(
    private _EmployeeService: EmployeeService,
    private gt: genericCustomStoreService,
    public router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private notifyService: NotifyService
  ) {}

  ngOnInit(): void {
    this.gt.getdropdowndata('Employee').subscribe((res: any[]) => {
      this.employeesdropdown = res;
    });
    this._EmployeeService.GetEmployeeMissionTypes().subscribe((res: any[]) => {
      this.missionTypes = res;
    });

    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.missionId = +params['id'];
        this.loadMission(this.missionId);
      }
    });
  }

  loadMission(id: number) {
    this.loading = true;
    this._EmployeeService.GetEmployeeMissionByid(id).subscribe({
      next: (res: any) => {
        this.formData = {
          name: res.name,
          descrption: res.description,
          missionLocation: res.missionLocation,
          missionType: res.missionType,
          isPaid: res.isPaid,
          employeeId: res.employeeId,
          visitStartDateTime: res.visitStartTime,
          visitEndDateTime: res.visitEndTime,
          isClientVisit: res.isClientVisit ?? false,
          clientName: res.clientName ?? '',
          clientPhone: res.clientPhone ?? '',
          hasUpcomingVisit: res.hasUpcomingVisit ?? false,
          upcomingVisitDate: res.upcomingVisitDate ?? null,
          isCollectedFromClient: res.isCollectedFromClient,
          collectedAmountFromClient: res.collectedAmountFromClient ?? null,
          collectionReason: res.collectionReason ?? '',
          collectionDate: res.collectionDate ?? null,
          expenses: res.expenses ?? [],
          transportations: res.transportations ?? []
        };
        this.loading = false;
      },
      error: () => {
        this.notifyService.notifyfunerr('حدث خطأ أثناء تحميل البيانات');
        this.loading = false;
      }
    });
  }

  // ===== Transportation =====
  addTransportation() {
    if (!this.newTransportation.fromDestination || !this.newTransportation.toDestination) {
      this.notifyService.notifyfunerr('يجب إدخال نقطة الانطلاق والوصول');
      return;
    }
    this.formData.transportations = [
      ...this.formData.transportations,
      { ...this.newTransportation, order: this.formData.transportations.length + 1 }
    ];
    this.newTransportation = { fromDestination: '', toDestination: '', cost: 0, order: 1, fromTime: null, toTime: null };
  }

  removeTransportation(index: number) {
    this.formData.transportations = this.formData.transportations
      .filter((_: any, i: number) => i !== index)
      .map((t: any, i: number) => ({ ...t, order: i + 1 }));
  }

  // ===== Expenses =====
  addExpense() {
    if (!this.newExpense.description || !this.newExpense.amount) {
      this.notifyService.notifyfunerr('يجب إدخال البيان والمبلغ');
      return;
    }
    this.formData.expenses = [...this.formData.expenses, { ...this.newExpense }];
    this.newExpense = { description: '', amount: 0 };
  }

  removeExpense(index: number) {
    this.formData.expenses = this.formData.expenses.filter((_: any, i: number) => i !== index);
  }

  // ===== Totals =====
  get transportationTotal(): number {
    return this.formData.transportations?.reduce((s: number, t: any) => s + (t.cost || 0), 0) ?? 0;
  }

  get expensesTotal(): number {
    return this.formData.expenses?.reduce((s: number, e: any) => s + (e.amount || 0), 0) ?? 0;
  }

  get totalCost(): number {
    return this.transportationTotal + this.expensesTotal;
  }

  get netCost(): number {
    const collected = this.formData.isCollectedFromClient
      ? (this.formData.collectedAmountFromClient || 0)
      : 0;
    return this.totalCost - collected;
  }

  // ===== Submit =====
  submit() {
    if (!this.formData.employeeId) {
      this.notifyService.notifyfunerr('يجب اختيار الموظف');
      return;
    }
    if (!this.formData.transportations?.length) {
      this.notifyService.notifyfunerr('يجب إضافة وسيلة مواصلات واحدة على الأقل');
      return;
    }
    if (!this.formData.visitStartDateTime || !this.formData.visitEndDateTime) {
      this.notifyService.notifyfunerr('يجب إدخال تاريخ بداية ونهاية الزيارة');
      return;
    }

    this.submitting = true;

    const request$ = this.isEditMode
      ? this._EmployeeService.updateEmployeeMission({ id: this.missionId, ...this.formData })
      : this._EmployeeService.AddEmployeeMission(this.formData);

    request$.subscribe({
      next: () => {
        this.notifyService.notifyfun(this.isEditMode ? 'تم التعديل بنجاح' : 'تم الإضافة بنجاح');
        this.router.navigate(['/EmployeeMission']);
        this.submitting = false;
      },
      error: () => {
        this.notifyService.notifyfunerr('حدث خطأ، يرجى المحاولة مرة أخرى');
        this.submitting = false;
      }
    });
  }

  cancel() {
    this.router.navigate(['/hr/EmployeeMission']);
  }
}